"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromFile = exports.FileTokenizer = void 0;

var AbstractTokenizer_1 = require("./AbstractTokenizer");

var peek_readable_1 = require("peek-readable");

var fs = require("./FsPromise");

var FileTokenizer = /*#__PURE__*/function (_AbstractTokenizer_1$) {
  _inherits(FileTokenizer, _AbstractTokenizer_1$);

  var _super = _createSuper(FileTokenizer);

  function FileTokenizer(fd, fileInfo) {
    var _this;

    _classCallCheck(this, FileTokenizer);

    _this = _super.call(this, fileInfo);
    _this.fd = fd;
    return _this;
  }
  /**
   * Read buffer from file
   * @param buffer
   * @param options - Read behaviour options
   * @returns Promise number of bytes read
   */


  _createClass(FileTokenizer, [{
    key: "readBuffer",
    value: function () {
      var _readBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buffer, options) {
        var offset, length, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                offset = 0;
                length = buffer.length;

                if (!options) {
                  _context.next = 9;
                  break;
                }

                if (!options.position) {
                  _context.next = 7;
                  break;
                }

                if (!(options.position < this.position)) {
                  _context.next = 6;
                  break;
                }

                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

              case 6:
                this.position = options.position;

              case 7:
                if (Number.isInteger(options.length)) {
                  length = options.length;
                } else {
                  length -= options.offset || 0;
                }

                if (options.offset) {
                  offset = options.offset;
                }

              case 9:
                if (!(length === 0)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(0));

              case 11:
                _context.next = 13;
                return fs.read(this.fd, buffer, offset, length, this.position);

              case 13:
                res = _context.sent;
                this.position += res.bytesRead;

                if (!(res.bytesRead < length && (!options || !options.mayBeLess))) {
                  _context.next = 17;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 17:
                return _context.abrupt("return", res.bytesRead);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readBuffer(_x, _x2) {
        return _readBuffer.apply(this, arguments);
      }

      return readBuffer;
    }()
    /**
     * Peek buffer from file
     * @param buffer
     * @param options - Read behaviour options
     * @returns Promise number of bytes read
     */

  }, {
    key: "peekBuffer",
    value: function () {
      var _peekBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(buffer, options) {
        var offset, length, position, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                offset = 0;
                length = buffer.length;
                position = this.position;

                if (!options) {
                  _context2.next = 10;
                  break;
                }

                if (!options.position) {
                  _context2.next = 8;
                  break;
                }

                if (!(options.position < this.position)) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

              case 7:
                position = options.position;

              case 8:
                if (Number.isInteger(options.length)) {
                  length = options.length;
                } else {
                  length -= options.offset || 0;
                }

                if (options.offset) {
                  offset = options.offset;
                }

              case 10:
                if (!(length === 0)) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", Promise.resolve(0));

              case 12:
                _context2.next = 14;
                return fs.read(this.fd, buffer, offset, length, position);

              case 14:
                res = _context2.sent;

                if (!((!options || !options.mayBeLess) && res.bytesRead < length)) {
                  _context2.next = 17;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 17:
                return _context2.abrupt("return", res.bytesRead);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function peekBuffer(_x3, _x4) {
        return _peekBuffer.apply(this, arguments);
      }

      return peekBuffer;
    }()
    /**
     * @param length - Number of bytes to ignore
     * @return resolves the number of bytes ignored, equals length if this available, otherwise the number of bytes available
     */

  }, {
    key: "ignore",
    value: function () {
      var _ignore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(length) {
        var bytesLeft;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                bytesLeft = this.fileInfo.size - this.position;

                if (!(length <= bytesLeft)) {
                  _context3.next = 6;
                  break;
                }

                this.position += length;
                return _context3.abrupt("return", length);

              case 6:
                this.position += bytesLeft;
                return _context3.abrupt("return", bytesLeft);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ignore(_x5) {
        return _ignore.apply(this, arguments);
      }

      return ignore;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", fs.close(this.fd));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);

  return FileTokenizer;
}(AbstractTokenizer_1.AbstractTokenizer);

exports.FileTokenizer = FileTokenizer;

function fromFile(_x6) {
  return _fromFile.apply(this, arguments);
}

function _fromFile() {
  _fromFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sourceFilePath) {
    var stat, fd;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fs.stat(sourceFilePath);

          case 2:
            stat = _context5.sent;

            if (stat.isFile) {
              _context5.next = 5;
              break;
            }

            throw new Error("File not a file: ".concat(sourceFilePath));

          case 5:
            _context5.next = 7;
            return fs.open(sourceFilePath, 'r');

          case 7:
            fd = _context5.sent;
            return _context5.abrupt("return", new FileTokenizer(fd, {
              path: sourceFilePath,
              size: stat.size
            }));

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fromFile.apply(this, arguments);
}

exports.fromFile = fromFile;